import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import GroupSettingsMenu from 'components/pages/navigation/GroupSettingsMenu'

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)
const mapStateToProps = () => ({})

const render = connect(mapStateToProps, mapDispatchToProps)(GroupSettingsMenu)

export default withRouter(render)
